import * as React from 'react';
import { clsx } from 'clsx';
import { UiKitThemeContext, useUiKitThemeContext } from '../internal/context';
import styles from './styles.module.css';
import { jsx as _jsx } from "react/jsx-runtime";
export const getThemeClassName = theme => {
  return clsx({
    'design-theme--light': theme === 'light' || !theme,
    'design-theme--dark': theme === 'dark',
    'design-theme--colored': theme === 'colored',
    'design-theme--onOverlay': theme === 'onOverlay'
  });
};
export const useUiKitTheme = () => {
  const {
    theme
  } = useUiKitThemeContext();
  return {
    theme,
    themeClassName: getThemeClassName(theme)
  };
};
export const Theme = _ref => {
  let {
    theme,
    children,
    displayContents
  } = _ref;
  const value = React.useMemo(() => ({
    theme: theme
  }), [theme]);
  if (!theme) {
    return /*#__PURE__*/_jsx("div", {
      children: children
    });
  }
  return /*#__PURE__*/_jsx(UiKitThemeContext.Provider, {
    value: value,
    children: /*#__PURE__*/_jsx("div", {
      className: clsx(getThemeClassName(theme), displayContents && styles['contents']),
      children: children
    })
  });
};